// extracted by mini-css-extract-plugin
export var footer = "_m3-0";
export var inherit = "_m3-1";
export var input = "_m3-2";
export var modalContent = "_m3-3";
export var quillEditor = "_m3-4";
export var subtitle = "_m3-5";